import React from 'react';
import '../constants/AssetsCss';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class Withdraw extends React.Component {
    constructor(props) {
        super(props);
        this.onAmountChanged = this.onAmountChanged.bind(this);
        this.WithdrawReq = this.WithdrawReq.bind(this);
        this.onMethodChanged = this.onMethodChanged.bind(this);
        this.state = {
            country: "",
            amount: "",
            method: "BTC",
            availablePaywallet: "0"
        }
    }
    componentDidMount() {
        this.getWithdrawHistory();
        this.getDashboardDetails();
    }
    onAmountChanged(event) {
        this.setState({ amount: event.target.value });
    }
    onMethodChanged(event) {
        this.setState({ method: event.target.value });
    }

    async WithdrawReq() {
        if (!this.state.amount) {
            toast("Enter a Amount");
            return;
        }
        // if (this.state.method === "TRX") {
        //     swal({
        //         title: "Under maintenance",
        //         text: "Will be back soon.",
        //         icon: "info"
        //     });
        //     return;
        // }
        let json = {
            amount: this.state.amount
        }
        let res = await GetORPostAsync("WidthdrawalConfirm.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status.toLowerCase() === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        swal("Please enter the login password", {
            content: "input",
            dangerMode: true,
            buttons: true,
        }).then((value) => {
            if (!value)
                return;
            let jsonstr = {
                amount: this.state.amount,
                method: this.state.method,
                OTP: value,
                tpassword:value
            };
            this.withdrawConfirm(JSON.stringify(jsonstr));
        });
    }
    async withdrawConfirm(json) {
        let res = await GetORPostAsync("WidthdrawalRequest.asp", "POST", json, localStorage.getItem("token"));
        if (res.status.toLowerCase() === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        toast(res.message);
        this.getDashboardDetails();
    }
    async getWithdrawHistory() {
        let res = await GetORPostAsync("WithdrawalReport.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            this.setState({ WithdrawHistoryTable: "<tr><td colSpan='4'>No Records</td></tr>" });
            return;
        }
        let str = "";
        for (let i = 0; i < res.items.length; i++) {
            str += '<tr><td class="bg-color-1 text-white">' + (i + 1) + '</td><td>' + res.items[i].widthdrawaldate + '</td><td>' + res.items[i].amount + '</td><td>' + res.items[i].ReceiveAddress + '</td></tr>';
            if (i === res.items.length - 1) {
                this.setState({ WithdrawHistoryTable: str });
            }
        }
    }
    async getDashboardDetails() {
        let res = await GetORPostAsync("GetDashboardDetails.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        this.setState(res);
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Withdraw</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body">
                            <h5 className=" mt-3 mb-3">Withdraw </h5>
                            <hr></hr>
                            <div class="form-body mt-4">
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div class="border border-3 p-4 rounded">
                                            <div class="card radius-10 border border-1 shadow-none">
                                                <div class="card-body">
                                                    <div class="d-flex align-items-center">
                                                        <div>
                                                            <p class="mb-0 text-white">Wallet Balance</p>
                                                            <h4 class="my-1">{this.state.availablePaywallet}</h4>
                                                        </div>
                                                        <div class="widgets-icons-2 bg-gradient-moonlit text-white ml-auto">
                                                            <svg className="side-menu__icon" style={{fill:'white'}} xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 16 16" width="16"><path d="M0 0h16v16H0V0z" fill="none" /><path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                                                <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z" /></svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mb-3"><label for="amounttowithdraw" class="form-label">Amount to withdraw</label><input type="text" class="form-control" placeholder="Withdraw amount" onChange={this.onAmountChanged} value={this.state.amount} /></div>
                                            {/* <div class="mb-3"><label for="walletaddress" class="form-label">Wallet address (BEP20)</label><input type="text" class="form-control" placeholder="Wallet address" value={this.state.walletaddress} onChange={this.onWalletAddressChanged} /></div> */}
                                            <div class="mb-3 mt-5">
                                                <div class="d-grid"><button onClick={this.WithdrawReq} type="submit" class="btn btn-primary w-100">Withdraw</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                <tr>
                                    <td>
                                        <label className="text-white">
                                            Wallet Balance
                                        </label>
                                    </td>
                                    <td className='text-center'>:</td>
                                    <td>
                                        <h4>  {this.state.availablePaywallet}</h4>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className="text-white">
                                            Amount
                                        </label>
                                    </td>
                                    <td className='text-center'>:</td>
                                    <td>
                                        <input type="text" className="col-lg-6 col-md-12 form-control" onChange={this.onAmountChanged} value={this.state.amount} placeholder="Amount" aria-label="Amount" tabIndex="1" />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label className="text-white">
                                            Wallet Address
                                        </label>
                                    </td>
                                    <td className='text-center'>:</td>
                                    <td>
                                        <input type="text" className="col-lg-6 col-md-12 form-control" value={this.state.walletaddress} onChange={this.onWalletAddressChanged} placeholder="Wallet address" aria-label="Wallet address" tabIndex="1" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className="text-white">
                                            Payment method
                                        </label>
                                    </td>
                                    <td className='text-center'>:</td>
                                    <td>
                                        <label className="custom-control custom-radio">
                                            <input type="radio" className="custom-control-input" name="example-radios" onChange={this.onMethodChanged} value="DNET" checked={this.state.method === "DNET"} />
                                            <span className="custom-control-label">DNET</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className="text-center">
                                        <button className="ml-2 mb-5 btn btn-color-1" onClick={this.WithdrawReq}>Withdraw</button>
                                    </td>
                                </tr>
                            </table> */}


                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Withdraw History</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table style={{ textAlign: "center" }} className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Received Address</th>
                                        </tr>
                                    </thead>
                                    <tbody dangerouslySetInnerHTML={{ __html: this.state.WithdrawHistoryTable }}>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default  withRouter(Withdraw);